const features = {
  // Temporary release switch. Set to true to restore the existing theme toggle.
  darkMode: false,
  // Temporary release switch. Set to true to restore BOM section page breaks when printing.
  bomPrintSectionsOnNewPage: false,
};

export default features;
